import noop from 'lodash/noop'
import { Marker as MaplibreMarker } from 'react-map-gl/maplibre'

type Props = {
  position: [number, number]
  children?: React.ReactNode
  IconComponent: React.ComponentType<any>
  onClick?: () => void
  style?: React.CSSProperties
}

const Marker = ({
  children,
  position,
  IconComponent,
  onClick = noop,
  ...rest
}: Props) => {
  return (
    <MaplibreMarker
      longitude={position[1]}
      latitude={position[0]}
      onClick={onClick}
      {...rest}
    >
      <IconComponent />
      {children}
    </MaplibreMarker>
  )
}

export default Marker
